import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  Z11DealerTransfersRequest,
  Z11GetSalesTypeRequest,
  Z11GetSalesTypeResponse,
} from '../models/holds-transfers.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HoldsTransfersService {
  constructor(private readonly http: HttpClient) {}

  getSalesType(
    requestPayload: Z11GetSalesTypeRequest
  ): Observable<Z11GetSalesTypeResponse> {
    const url = `/holds-transfers/get-sales-type`;
    console.log(requestPayload);
    return this.http.post<Z11GetSalesTypeResponse>(url, requestPayload);
  }
  getDealerTransfers(
    requestPayload: Z11DealerTransfersRequest
  ): Observable<any> {
    const url = `/holds-transfers/get-dealer-transfers`;
    console.log(requestPayload);
    return this.http.post<any>(url, requestPayload);
  }
}
